import React from "react";

import { LabelsAssignment, Tabs } from "@features/breakdown-v2";

export default () => (
  <div className="p-6">
    <Tabs />
    <LabelsAssignment />
  </div>
);
